module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandWinterTour2011Handdrawn3colorscreenprint.671e765d.webp";